import { FC } from 'react';
import { Cross } from '@edikk-edikk/icon/Cross';
import { SvgIcon } from '@edikk-edikk/svg-icon';
import { Button, ButtonSize, ButtonVariant } from '@edikk-edikk/country-layout-black';
import { useAdvertDetailContext } from '#advertDetail/hooks';

const GalleryHeaderClose: FC = () => {
  const { onClose } = useAdvertDetailContext();

  if (!onClose) {
    return null;
  }

  return (
    <Button variant={ButtonVariant.black} size={ButtonSize.lg} circle onClick={onClose} aria-label="Close">
      <SvgIcon Component={Cross} isWithoutFill />
    </Button>
  );
};

export { GalleryHeaderClose };
